import React from "react";
import { ModalBody, ModalFooter, Button } from "reactstrap";

const ModalKeyValueViewer = ({ data, toggle }) => {
  const prettyValue = React.useMemo(() => {
    if (!data?.value) return "{}";
    try {
      return JSON.stringify(data.value, null, 2);
    } catch (error) {
      return String(data.value);
    }
  }, [data]);

  return (
    <form className="tablelist-form">
      <ModalBody>
        <div className="mb-3">
          <label className="form-label fw-semibold">Key</label>
          <p className="mb-3">{data?.keyName || "-"}</p>
          <label className="form-label fw-semibold">Value</label>
          <pre className="bg-light p-3 rounded" style={{ whiteSpace: "pre-wrap" }}>
            {prettyValue}
          </pre>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-end">
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </form>
  );
};

export default ModalKeyValueViewer;

